export default __webpack_public_path__ + "static/media/anihope.7c0112b9.png";